import moment from "moment";


export class Overwatch {
    constructor(taxis, bookings, tUseZoneBasedDispatch) {
        this.taxis = taxis;
        this.bookings = bookings;

        this.LATE_TAXIS_ASAP_TIME = 10;
        this.ABOUT_TO_CLEAR_TIME = 1;

        if (tUseZoneBasedDispatch != null) {
            this.useZoneBasedDispatch = tUseZoneBasedDispatch;
        } else {
            this.useZoneBasedDispatch = false;
        }
    }

    static CATEGORIES() {
        return [{
                key: "available",
                name: "Available",
                color: "white",
                letter: ""
            },
            {
                key: "about_to_clear",
                name: "About to Clear",
                color: "#6cff88",
                letter: "C"
            },
            {
                key: "pob",
                name: "POB",
                color: "#6cddff",
                letter: "P"
            },
            {
                key: "arrived",
                name: "Arrived",
                color: "#e699fd",
                letter: "A"
            }, {
                key: "running_late",
                name: "Running Late",
                color: "#ff6c6c",
                letter: "L"
            },
            {
                key: "en_route",
                name: "En route to pickup",
                color: "#fff96c",
                letter: "E"
            },
            {
                key: "on_break",
                name: "On Break",
                color: "#dadada",
                letter: "B"
            },
            {
                key: "offline",
                name: "Offline",
                color: "#cacaca",
                dark: true,
                letter: ""
            }
        ]
    }
    compareTaxis(a, b) {
        var state_precedence = [
            "job_sent",
            "available",
            "running_late",
            "on_job",
            "about_to_clear",
            "arrived",
            "pob",
            "on_break",
            "sin_bin"
        ];

        if (a.in_emergency && b.in_emergency) {
            if (a.last_job_time < b.last_job_time) {
                return -1;
            } else if (a.last_job_time > b.last_job_time) {
                return 1;
            } else {
                return 0;
            }
        }

        if (a.offline) return 1;
        if (b.offline) return -1;

        if (a.in_emergency) return -1;
        if (b.in_emergency) return 1;

        var aState = a.state;

        if (aState == "on_job") {
            var a_job = this.getJobForTaxi(a.id, this.bookings);

            if (a_job == null) {
                return 1;
            }

            if (a_job.arrived_time != null) {
                aState = "arrived";
            } else {
                var now = new Date().getTime();
                var pickup = a_job.pickup_timestamp;

                if (a_job.asap) {
                    pickup = pickup + this.LATE_TAXIS_ASAP_TIME * 60 * 1000;
                }

                if (now > pickup) {
                    aState = "running_late";
                }
            }

        } else if (aState == "pob") {

            var a_job = this.getJobForTaxi(a.id, this.bookings);

            var a_eta = 9999;

            if (a_job == null) {
                return 1;
            }

            for (var t in a_job.taxis) {
                var this_taxi = a_job.taxis[t];
                if (a.id == this_taxi.id) {
                    if (this_taxi.eta != undefined) {
                        a_eta = this_taxi.eta;
                    }
                }
            }

            if (a_eta <= this.ABOUT_TO_CLEAR_TIME) {
                aState = "about_to_clear";
            }
        }

        var bState = b.state;

        if (bState == "on_job") {
            var b_job = this.getJobForTaxi(b.id, this.bookings);

            if (b_job == null) {
                return 1;
            }

            if (b_job.arrived_time != null) {
                bState = "arrived";
            } else {
                var now = new Date().getTime();
                var pickup = b_job.pickup_timestamp;

                if (b_job.asap) {
                    pickup = pickup + this.LATE_TAXIS_ASAP_TIME * 60 * 1000;
                }

                if (now > pickup) {
                    bState = "running_late";
                }
            }

        } else if (bState == "pob") {

            var b_job = this.getJobForTaxi(b.id, this.bookings);

            var b_eta = 9999;

            if (b_job == null) {
                return 1;
            }

            for (var t in b_job.taxis) {
                var this_taxi = b_job.taxis[t];
                if (b.id == this_taxi.id) {
                    if (this_taxi.eta != undefined) {
                        b_eta = this_taxi.eta;
                    }
                }
            }

            console.log(b_eta + " " + this.ABOUT_TO_CLEAR_TIME);

            if (b_eta <= this.ABOUT_TO_CLEAR_TIME) {
                bState = "about_to_clear";
            }
        }

        // If pob, let's see who will probably clear first.
        if ((aState == "running_late" && bState == "running_late") ||
            (aState == "about_to_clear" && bState == "about_to_clear")) {
            if (a_job.id < b_job.id) {
                return -1;
            } else if (a_job.id > b_job.id) {
                return 1;
            } else {
                return 0;
            }
        }

        if (aState == "arrived" && bState == "arrived") {
            if (
                a_job.arrived_time != undefined &&
                b_job.arrived_time != undefined
            ) {
                if (a_job.arrived_time < b_job.arrived_time) {
                    return -1;
                } else if (a_job.arrived_time > b_job.arrived_time) {
                    return 1;
                } else {
                    return 0;
                }
            }
        }

        // If pob, let's see who will probably clear first.
        if (aState == "pob" && bState == "pob") {
            // var a_job = this.getJobForTaxi(a.id, this.bookings);
            // var b_job = this.getJobForTaxi(b.id, this.bookings);

            // var a_eta = 99999;
            // var b_eta = 99999;

            // if (a_job != undefined && a_job.eta != undefined) {
            //     a_eta = a_job.eta;
            // }

            // if (b_job != undefined && b_job.eta != undefined) {
            //     b_eta = b_job.eta;
            // }

            // if (a_eta < b_eta) {
            //     return -1;
            // } else if (a_eta > b_eta) {
            //     return 1;
            // } else {
            //     if (a.last_job_time < b.last_job_time) {
            //         return -1;
            //     } else if (a.last_job_time > b.last_job_time) {
            //         return 1;
            //     } else {
            //         return 0;
            //     }
            // }

            if (a_job.id < b_job.id) {
                return -1;
            } else if (a_job.id > b_job.id) {
                return 1;
            } else {
                return 0;
            }
        }

        if (aState == "on_job" && bState == "on_job") {
            var a_job = this.getJobForTaxi(a.id, this.bookings);
            var b_job = this.getJobForTaxi(b.id, this.bookings);

            if (a_job == undefined) {
                return 1;
            }

            if (b_job == undefined) {
                return -1;
            }

            if (
                a_job.arrived_time != undefined &&
                b_job.arrived_time != undefined
            ) {
                if (a_job.arrived_time < b_job.arrived_time) {
                    return -1;
                } else if (a_job.arrived_time > b_job.arrived_time) {
                    return 1;
                } else {
                    return 0;
                }
            }

            if (
                a_job.arrived_time != undefined &&
                b_job.arrived_time == undefined
            ) {
                return -1;
            }

            if (
                a_job.arrived_time == undefined &&
                b_job.arrived_time != undefined
            ) {
                return 1;
            }

            if (a_job.id < b_job.id) {
                return -1;
            } else if (a_job.id > b_job.id) {
                return 1;
            } else {
                return 0;
            }
        }

        var val =
            state_precedence.indexOf(aState) - state_precedence.indexOf(bState);

        if (val == 0) {
            if (this.useZoneBasedDispatch) {
                if (a.taxi_zone_info.queue_time < b.taxi_zone_info.queue_time) {
                    return -1;
                } else if (a.taxi_zone_info.queue_time > b.taxi_zone_info.queue_time) {
                    return 1;
                } else {
                    return 0;
                }
            } else {
                if (a.last_job_time < b.last_job_time) {
                    return -1;
                } else if (a.last_job_time > b.last_job_time) {
                    return 1;
                } else {
                    return 0;
                }
            }
        } else {
            return val;
        }
    }
    tooltipForTaxi(taxi) {
        return (
            "<b>" +
            taxi.driver.name +
            "</b><br>" + "<b>" +
            taxi.num_seats + ' seats, ' + taxi.taxi_description + "</b>" + "<br><b>Logged in for </b>" +
            taxi.logged_in_for +
            (taxi.state == "available" ?
                "</b><br><b>Last Job </b>" + taxi.last_job_time_pretty :
                "") +
            "</b><br><b>Last Update </b>" +
            taxi.last_update + "<br>"
        );
    }
    stateForTaxi(taxi) {
        var stateString = "";
        // idle is nothin

        if (taxi.in_emergency) {
            stateString += "_EMERGENCY_";
        }

        // break is a B
        // if (taxi.state == "on_break") {
        //     stateString += "B";
        // } else if (taxi.state == "on_job") {
        //     var bookingTaxi = this.getCurrentBookingTaxiForTaxi(
        //         taxi.id,
        //         this.bookings
        //     );

        //     if (bookingTaxi == null) {
        //         stateString += "_error";
        //         return taxi.driver.id + stateString;
        //     }

        //     var booking = bookingTaxi.booking;
        //     var taxiEta = bookingTaxi.taxi;

        //     if (booking.arrived_time != null) {
        //         // arrived is an A
        //         stateString += "A";
        //     } else {
        //         // on way to pickup is a E
        //         stateString += "E";
        //     }

        // if (taxi.state == "pob") {
        //     var bookingTaxi = this.getCurrentBookingTaxiForTaxi(
        //         taxi.id,
        //         this.bookings
        //     );

        //     if (bookingTaxi == null) {
        //         stateString += "_error";
        //         return taxi.driver.id + stateString;
        //     }

        //     var booking = bookingTaxi.booking;
        //     var taxiEta = bookingTaxi.taxi;

        //     if (taxiEta.eta != null && taxiEta.eta <= this.ABOUT_TO_CLEAR_TIME) {
        //         // About to clear (clearing) is C
        //         stateString += "C";
        //     } else {
        //         // POB is a P
        //         stateString += "P";
        //     }
        // }

        // if (taxi.state == "job_sent" || taxi.has_follow_on_job_offer == true) {
        //     stateString += "O";
        // }

        // Number of follow ons is F1, F2 etc
        if (taxi.follow_on_job_count > 0) {
            stateString += `F${taxi.follow_on_job_count}`;
        }
        if (taxi.offline) {
            stateString += " off";
        }

        return '&nbsp;<b>' + taxi.driver.callsign + ' </b> &nbsp;<b style="background-color: #00ff00;"> ' + stateString + '</b >';
    }
    driverIsOnline(driverId) {

        var onlineTaxi = this.taxis.find(function (t) {
            return t.driver.id == driverId && !t.offline;
        });

        return onlineTaxi != null;
    }
    sortTaxisByState(taxis) {
        return taxis.sort(this.compareTaxis.bind(this));
    }
    getJobForTaxi(taxiID) {
        var bookingTaxi = this.getCurrentBookingTaxiForTaxi(taxiID);
        return bookingTaxi != null ? bookingTaxi.booking : null;
    }
    getJob(jobID) {
        return this.bookings.find(function (b) {
            return b.id == jobID;
        });
    }
    getCurrentBookingTaxiForTaxi(taxiID) {
        for (var index = 0; index < this.bookings.length; index++) {
            var booking = this.bookings[index];
            if (booking.taxis != null) {
                for (var jindex = 0; jindex < booking.taxis.length; jindex++) {
                    var taxi = booking.taxis[jindex];
                    if (taxi.id == taxiID) {
                        return {
                            booking: booking,
                            taxi: taxi
                        };
                    }
                }
            }
        }
    }
    getAcceptedFollowOnBookingsForTaxi(taxi) {

        if (taxi.follow_on_job_ids != null) {
            var bookings = this.bookings.filter(function (b) {
                return taxi.follow_on_job_ids.includes(b.id) && b.follow_on_taxis != null;
            });

            bookings.sort(function (a, b) {
                return taxi.follow_on_job_ids.indexOf(a.id) - taxi.follow_on_job_ids.indexOf(b.id);
            });

            // order 

            return bookings;
        }

        return [];
    }
    categoryForTaxi(taxi) {

        if (taxi.offline) {
            return "offline";
        }

        if (taxi.state == "pob") {
            var job = this.getJobForTaxi(taxi.id);

            if (job == null) {
                return;
            }

            var eta = 9999;

            for (var t in job.taxis) {
                var this_taxi = job.taxis[t];
                if (taxi.id == this_taxi.id) {
                    if (this_taxi.eta != undefined) {
                        eta = this_taxi.eta;
                    }
                }
            }

            if (eta != undefined) {
                // console.log("ETA " + eta);
                if (eta <= this.ABOUT_TO_CLEAR_TIME) {
                    return "about_to_clear";
                }
            } else {
                // console.log("ETA UNDEFINED");
            }

            return "pob";
        } else if (taxi.state == "on_job") {
            var job = this.getJobForTaxi(taxi.id);


            if (job == null) {
                return;
            }

            if (job.arrived_time != null) {
                return "arrived";
            }

            var now = new Date().getTime();
            var pickup = job.pickup_timestamp;

            if (job.asap) {
                pickup = pickup + this.LATE_TAXIS_ASAP_TIME * 60 * 1000;
            }

            if (now > pickup) {
                return "running_late";
            }

            return "en_route";
        } else if (taxi.state == "job_sent") {
            return "job_sent"
        } else if (taxi.state == "available") {
            return "available";
        } else if (taxi.state == "on_break") {
            return "on_break";
        }
    }
    categoryForTaxiFollowOn(taxi, job) {

        if (taxi.offline) {
            return "offline";
        }

        if (job == null) {
            return;
        }

        var eta = 9999;

        for (var t in job.follow_on_taxis) {
            var this_taxi = job.follow_on_taxis[t];
            if (taxi.id == this_taxi.id) {
                if (this_taxi.eta != undefined) {
                    eta = this_taxi.eta;
                }
            }
        }

        if (eta != undefined) {

            var tNow = new Date().getTime();
            var tPickup = job.pickup_timestamp;

            if (job.asap) {
                tPickup = tPickup + (this.LATE_TAXIS_ASAP_TIME * 60 * 1000);
            }

            if (tNow > tPickup) {
                return "running_late";
            } else {
                return "available";
            }

        }
    }
    colorForTaxi(taxi) {
        var category = this.categoryForTaxi(taxi);

        if (category == null) {
            return "#00ff00";
        } else if (category == "job_sent") {
            return "#6cffbb";
        } else {
            var categoryObject = Overwatch.CATEGORIES().find(function (c) {
                return (c.key == category);
            });

            if (categoryObject != null) {
                return categoryObject.color;
            } else {
                return "#0000ff";
            }
        }
    }
    colorForFollowOnTaxi(taxi, booking) {

        var category = this.categoryForTaxiFollowOn(taxi, booking);


        if (category == null) {
            return "#00ff00";
        } else if (category == "job_sent") {
            return "#b7dda7";
        } else {
            var categoryObject = Overwatch.CATEGORIES().find(function (c) {
                return (c.key == category);
            });

            if (categoryObject != null) {
                return categoryObject.color;
            } else {
                return "#0000ff";
            }
        }
    }
    static nameForCustomerForBooking(b) {
        if (b.customer_name != null) {
            return b.customer_name;
        } else {
            return "";
        }
    }
    static prettifyAddress(d) {
        if (d.endsWith(", UK")) {
            d = d.replace(", UK", "");
        }

        return d;
    }
    static viasForBooking(b) {
        if (b.destinations != null && b.destinations.length > 1) {
            var viaHTML = "<ul class='via-list'>";

            for (var i = 1; i < b.destinations.length; i++) {
                viaHTML += `<li>${Overwatch.prettifyAddress(b.destinations[i].description)}</li>`;
            }

            return viaHTML;
        } else {
            return "</ul>";
        }
    }
    static destinationForBooking(b) {
        if (b.destinations != null && b.destinations.length > 0) {
            return Overwatch.prettifyAddress(b.destinations[0].description);
        } else {
            return "-";
        }
    }
    static durationToHoursMinutesString(duration, minutesString) {
        var durationAsHours = duration.asHours();

        var lateTimeString = "";

        if (durationAsHours < 0) {
            durationAsHours = -durationAsHours;
        }

        if (durationAsHours > 1) {
            lateTimeString += Math.floor(durationAsHours).toFixed(0) + "h";
        }

        var minutes = durationAsHours - Math.floor(durationAsHours);

        if (minutes != 0 && durationAsHours < 6) {
            lateTimeString += Math.floor(60 * minutes).toFixed(0) + minutesString;
        }

        return lateTimeString;
    }
    static secondsToHoursMinutesString(seconds) {
        var duration = moment.duration(seconds, "seconds");

        var hoursMinutesString = this.durationToHoursMinutesString(duration, "m");

        return hoursMinutesString;
    }
}